"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DockerPull = void 0;
const docker_registry_v2_client_1 = require("@snyk/docker-registry-v2-client");
const registryClient = require("@snyk/docker-registry-v2-client");
const crypto = require("crypto");
const fs = require("fs");
const os = require("os");
const path = require("path");
const tar = require("tar-fs");
const crypto_1 = require("crypto");
const util_1 = require("util");
const subProcess = require("./sub-process");
const tmp = require("./tmp");
const errors_1 = require("./errors");
const readFile = (0, util_1.promisify)(fs.readFile);
const link = (0, util_1.promisify)(fs.link);
const stat = (0, util_1.promisify)(fs.stat);
const DEFAULT_LAYER_JSON = {
    created: "0001-01-01T00:00:00Z",
    container_config: {
        Hostname: "",
        Domainname: "",
        User: "",
        AttachStdin: false,
        AttachStdout: false,
        AttachStderr: false,
        Tty: false,
        OpenStdin: false,
        StdinOnce: false,
        Env: null,
        Cmd: null,
        Image: "",
        Volumes: null,
        WorkingDir: "",
        Entrypoint: null,
        OnBuild: null,
        Labels: null,
    },
};
class DockerPull {
    static async findDockerBinary() {
        return subProcess
            .execute("which", ["docker"], undefined, undefined, true)
            .then((cmdOutput) => cmdOutput.stdout.trim())
            .catch((cmdOutput) => {
            throw new Error(cmdOutput.stderr);
        });
    }
    /**
     * Downloads an image from a Container Registry.
     */
    async pull(registryBase, repo, tag, opt) {
        var _a, _b;
        const loadImage = (opt === null || opt === void 0 ? void 0 : opt.loadImage) === undefined ? true : opt.loadImage;
        const manifest = await registryClient.getManifest(registryBase, repo, tag, opt === null || opt === void 0 ? void 0 : opt.username, opt === null || opt === void 0 ? void 0 : opt.password, opt === null || opt === void 0 ? void 0 : opt.reqOptions, opt === null || opt === void 0 ? void 0 : opt.platform, opt === null || opt === void 0 ? void 0 : opt.observer);
        const indexDigest = (_a = manifest.indexDigest) !== null && _a !== void 0 ? _a : undefined;
        const manifestDigest = (_b = manifest.manifestDigest) !== null && _b !== void 0 ? _b : undefined;
        if (manifest.schemaVersion !== 2) {
            throw new errors_1.InvalidManifestSchemaVersionError(manifest.schemaVersion);
        }
        const imageConfigMetadata = manifest.config;
        const imageConfig = await registryClient.getImageConfig(registryBase, repo, imageConfigMetadata.digest, opt === null || opt === void 0 ? void 0 : opt.username, opt === null || opt === void 0 ? void 0 : opt.password, opt === null || opt === void 0 ? void 0 : opt.reqOptions, opt === null || opt === void 0 ? void 0 : opt.observer);
        const t0 = Date.now();
        const layersConfigs = manifest.layers;
        const blobDir = tmp.dirSync();
        const missingLayers = await this.downloadLayers(blobDir, layersConfigs, registryBase, repo, opt === null || opt === void 0 ? void 0 : opt.username, opt === null || opt === void 0 ? void 0 : opt.password, opt === null || opt === void 0 ? void 0 : opt.reqOptions, opt === null || opt === void 0 ? void 0 : opt.observer);
        const stagingDirPath = opt.stagingDirPath
            ? opt.stagingDirPath
            : os.tmpdir();
        const pullDuration = Date.now() - t0;
        let imageDigest;
        const stagingDir = this.createDownloadedImageDestination(stagingDirPath, opt === null || opt === void 0 ? void 0 : opt.imageSavePath);
        try {
            if ((manifest === null || manifest === void 0 ? void 0 : manifest.manifestContentType) === docker_registry_v2_client_1.contentTypes.OCI_MANIFEST_V1) {
                await this.buildOCIImage(imageConfigMetadata.digest, manifest, imageConfig, missingLayers, blobDir, stagingDir);
            }
            else {
                await this.buildImage(imageConfigMetadata.digest, imageConfig, layersConfigs, missingLayers, blobDir, stagingDir);
            }
            if (loadImage) {
                imageDigest = await this.loadImage(registryBase, repo, tag, stagingDir);
            }
        }
        catch (err) {
            throw new Error(err.stderr);
        }
        finally {
            try {
                // Check is the image should be saved for debugging
                const saveMatcher = Object.assign(Object.assign({}, opt), { registryBase,
                    repo,
                    tag });
                for (const [name, requestMatcher] of Object.entries(await this.saveRequests())) {
                    if (Object.keys(requestMatcher).every((key) => requestMatcher[key] === saveMatcher[key])) {
                        await link(path.join(stagingDir.name, "image.tar"), path.join(stagingDirPath, `${name}-${(0, crypto_1.randomUUID)()}.tar`));
                        break;
                    }
                }
            }
            catch (err) {
                console.error("pullSaveRequest error: ", err);
            }
            blobDir.removeCallback();
            if (loadImage) {
                stagingDir.removeCallback();
            }
        }
        return {
            imageDigest,
            stagingDir: loadImage ? null : stagingDir,
            cachedLayersDigests: [],
            missingLayersDigests: missingLayers.map((layer) => layer.config.digest),
            pullDuration,
            indexDigest,
            manifestDigest,
        };
    }
    async downloadLayers(blobDir, layersConfigs, registryBase, repo, username, password, reqOptions = {}, observer) {
        return await Promise.all(layersConfigs.map(async (config) => {
            const blobName = crypto.randomUUID();
            await registryClient.downloadLayer(path.join(blobDir.name, blobName), registryBase, repo, config.digest, username, password, reqOptions, observer);
            return { config, blobName };
        }));
    }
    async saveRequests() {
        const saveRequestsPath = path.join(os.tmpdir(), "pullSaveRequest.json");
        try {
            if (await stat(saveRequestsPath)) {
                return JSON.parse((await readFile(saveRequestsPath)).toString("utf-8"));
            }
        }
        catch (err) {
            return {};
        }
    }
    async buildOCIImage(imageDigest, manifest, imageConfig, layers, blobDir, stagingDir) {
        const pack = tar.pack(blobDir.name, {
            // write layers
            entries: layers.map((layer) => layer.blobName),
            map(header) {
                const layer = layers.find((layer) => layer.blobName == header.name);
                const digest = layer.config.digest.replace("sha256:", "");
                header.name = path.join("blobs", "sha256", digest);
                return header;
            },
            finalize: false,
            finish(pack) {
                const configContent = JSON.stringify(imageConfig);
                const configDigest = imageDigest.replace("sha256:", "");
                pack.entry({ name: path.join("blobs", "sha256", configDigest) }, configContent);
                // Ensure config digest and size is accurate following serialization round trip
                manifest.config.digest = `sha256:${configDigest}`;
                manifest.config.size = Buffer.byteLength(configContent, "utf8");
                // Unset properties added by docker-registry-v2-client
                manifest.indexDigest = undefined;
                manifest.manifestDigest = undefined;
                manifest.manifestContentType = undefined;
                const manifestContent = JSON.stringify(manifest);
                const manifestDigest = crypto
                    .createHash("sha256")
                    .update(manifestContent)
                    .digest("hex")
                    .toLowerCase();
                pack.entry({ name: path.join("blobs", "sha256", manifestDigest) }, manifestContent);
                const indexContent = JSON.stringify({
                    schemaVersion: 2,
                    mediaType: docker_registry_v2_client_1.contentTypes.OCI_INDEX_V1,
                    manifests: [
                        {
                            mediaType: docker_registry_v2_client_1.contentTypes.OCI_MANIFEST_V1,
                            size: Buffer.byteLength(manifestContent, "utf8"),
                            digest: `sha256:${manifestDigest}`,
                        },
                    ],
                });
                pack.entry({ name: "index.json" }, indexContent);
                const ociLayoutContent = JSON.stringify({
                    imageLayoutVersion: "1.0.0",
                });
                pack.entry({ name: "oci-layout" }, ociLayoutContent, () => {
                    pack.finalize();
                });
            },
        });
        const imagePath = path.join(stagingDir.name, "image.tar");
        const file = fs.createWriteStream(imagePath);
        pack.pipe(file);
        return new Promise((resolve, reject) => {
            file.on("close", () => resolve(path.join(imagePath)));
            file.on("error", (err) => reject(err));
        });
    }
    async buildImage(imageDigest, imageConfig, layersConfigs, layers, blobDir, stagingDir) {
        // generate layer metadata
        let parentDigest;
        const layerMetadata = {};
        for (const layerConfig of layersConfigs) {
            const digest = layerConfig.digest.replace("sha256:", "");
            let json = Object.assign({}, { id: digest }, DEFAULT_LAYER_JSON);
            if (parentDigest) {
                json = Object.assign({ parent: parentDigest });
            }
            parentDigest = digest;
            layerMetadata[digest] = {
                json: JSON.stringify(json),
                version: "1.0",
            };
        }
        const pack = tar.pack(blobDir.name, {
            // write layers
            entries: layers.map((layer) => layer.blobName),
            map(header) {
                const layer = layers.find((layer) => layer.blobName === header.name);
                const digest = layer.config.digest.replace("sha256:", "");
                header.name = path.join(digest, "layer.tar");
                return header;
            },
            finalize: false,
            finish(pack) {
                // write layer metadata
                for (const digest of Object.keys(layerMetadata)) {
                    const metadata = layerMetadata[digest];
                    pack.entry({ name: path.join(digest, "json") }, metadata.json);
                    pack.entry({ name: path.join(digest, "VERSION") }, metadata.version);
                }
                imageDigest = imageDigest.replace("sha256:", "");
                // write image json
                pack.entry({ name: `${imageDigest}.json` }, JSON.stringify(imageConfig));
                // write manifest.json
                const manifestJson = [
                    {
                        Config: `${imageDigest}.json`,
                        RepoTags: null,
                        Layers: layersConfigs.map((config) => `${config.digest.replace("sha256:", "")}/layer.tar`),
                    },
                ];
                pack.entry({ name: "manifest.json" }, JSON.stringify(manifestJson), () => {
                    pack.finalize();
                });
            },
        });
        const imagePath = path.join(stagingDir.name, "image.tar");
        const file = fs.createWriteStream(imagePath);
        pack.pipe(file);
        return new Promise((resolve, reject) => {
            file.on("close", () => resolve(path.join(imagePath)));
            file.on("error", (err) => reject(err));
        });
    }
    async loadImage(registryBase, repo, tag, stagingDir) {
        const dockerBinary = await DockerPull.findDockerBinary();
        const stdout = (await subProcess.execute(dockerBinary, ["load", "-i", "image.tar"], stagingDir.name)).stdout;
        // Loaded image ID: sha256:36456e9e9cb7c4b17d97461a5aeb062a481401e3d2b559285c7083d8e7f8efa6
        const imgDigest = stdout.split("sha256:")[1].trim();
        await subProcess.execute(dockerBinary, [
            "tag",
            `${imgDigest}`,
            `${registryBase}/${repo}:${tag}`,
        ]);
        return imgDigest;
    }
    createDownloadedImageDestination(stagingDirPath, imageSavePath) {
        if (!imageSavePath) {
            return tmp.dirSync({ path: stagingDirPath });
        }
        return {
            name: imageSavePath,
            removeCallback: () => {
                /* do nothing */
            },
        };
    }
}
exports.DockerPull = DockerPull;
//# sourceMappingURL=docker-pull.js.map